import { toast, Toaster } from "sonner";
import { BrowserRouter as Router } from "react-router-dom";
import { useEffect } from "react";
import Routes from "./Routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/tokens.css";
import "./styles/menus.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./App.css";
import { store } from "./App/store.js";
import { clearPermissions } from "./features/permissions/permissionSlice.js";
import { logout } from "./features/auth/authSlice.js";
import { isAuthenticated } from "./Util/jwt";
import watermark from "./Containers/Pictures/watermark.png";
import SopChecklistHost from "./Components/Sop/SopChecklistHost.jsx";
import { WhatsAppLiveProvider } from "./hooks/useWhatsAppLive.js";
import { FlashToast } from "./Util/flashToast.js";

const App = () => {
    const navigate = (url) => {
        window.location.href = url;
    };

    useEffect(() => {
        document.title = "Virangi";

        const setFavicon = (href) => {
            let favicon = document.querySelector("link[rel='icon']");
            if (!favicon) {
                favicon = document.createElement("link");
                favicon.setAttribute("rel", "icon");
                document.head.appendChild(favicon);
            }
            favicon.setAttribute("type", "image/png");
            favicon.setAttribute("href", href);
        };

        const img = new Image();
        img.onload = () => {
            const size = 256;
            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;

            const ctx = canvas.getContext("2d");
            if (!ctx) {
                setFavicon(watermark);
                return;
            }

            // Fit the watermark into a square icon without stretching.
            const scale = Math.min(size / img.width, size / img.height);
            const drawWidth = img.width * scale;
            const drawHeight = img.height * scale;
            const x = (size - drawWidth) / 2;
            const y = (size - drawHeight) / 2;

            ctx.clearRect(0, 0, size, size);
            ctx.drawImage(img, x, y, drawWidth, drawHeight);
            setFavicon(canvas.toDataURL("image/png"));
        };

        img.onerror = () => setFavicon(watermark);
        img.src = watermark;
    }, []);

    // A mouse wheel over a focused number field silently changes the quantity or
    // amount (Chrome/Firefox). Blur it so the wheel scrolls the page instead.
    useEffect(() => {
        const onWheel = (e) => {
            const el = document.activeElement;
            if (el && el === e.target && el.type === "number") el.blur();
        };
        document.addEventListener("wheel", onWheel, { passive: true });
        return () => document.removeEventListener("wheel", onWheel);
    }, []);

    useEffect(() => {
        if (!isAuthenticated() && window.location.pathname !== "/login") {
            store.dispatch(logout());
            store.dispatch(clearPermissions());
            navigate("/login");
        }
    }, []);

    return (
        <div>
            {/* Phones: toasts lift above a Save bar only while one is at the bottom of
                the screen (FormActions → html[data-sticky-save], App.css). */}
            <Toaster position="bottom-right" richColors closeButton />
            <SopChecklistHost />
            <Router>
                <FlashToast />
                <WhatsAppLiveProvider>
                    <Routes />
                </WhatsAppLiveProvider>
            </Router>
        </div>
    );
};

export default App;
